jQuery(document).ready(function () {

    $(document).on('click', '.dnJs-ticketCheckIn', function (e) {
        e.preventDefault();

        var el                  = $(this);
        var url                 = el.data('url');
        var questionText        = el.data('question');
        var container           = el.closest('.dnFormTicketCheckInReplace');

        var r = confirm(questionText);
        if (r == true) {
            $.ajax({
                type: "POST",
                url: url,
                beforeSend: function () {
                    el.enableLoadingAnimation(true);
                },
                success: function (response) {
                    container.html(response);
                    $('#ticket_check_in_code').val('');
                    $('#ticket_check_in_code').focus();
                    el.enableLoadingAnimation(false);
                },
                error: function () {
                    el.enableLoadingAnimation(false);
                }
            });
        }
    });
});
